import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ShieldAlert } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(false);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data.user);
        window.history.replaceState(null, "", "/editor");
        navigate("/editor", { state: { user: res.data.user } });
      } catch (e) {
        if (e.response?.status === 403) {
          setDenied(true);
        } else {
          setError(true);
          setTimeout(() => navigate("/login"), 1800);
        }
      }
    })();
  }, [navigate, setUser]);

  if (denied) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f7f5f0] font-editor px-6" dir="rtl">
        <div className="max-w-md w-full bg-white border border-[#E5E2D9] rounded-2xl p-10 text-center">
          <div className="w-14 h-14 mx-auto mb-5 rounded-full bg-red-50 flex items-center justify-center">
            <ShieldAlert className="w-7 h-7 text-[#8C3A3A]" />
          </div>
          <h1 className="text-xl font-bold text-[#1A1D1A] mb-2">אין לחשבון הזה הרשאת גישה</h1>
          <p className="text-[#5C635C] leading-relaxed mb-7">
            הכניסה לממשק הניהול מוגבלת למנהלי מערכת מורשים בלבד. אם לדעתך זו טעות, פני למנהל/ת האתר כדי
            שיוסיפו את כתובת המייל שלך.
          </p>
          <button data-testid="denied-back-btn" onClick={() => navigate("/login")}
                  className="w-full bg-[#4A5D4E] hover:bg-[#3d4d41] text-white rounded-full py-3 font-semibold transition-colors">
            חזרה למסך ההתחברות
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f7f5f0] font-editor" dir="rtl">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#4A5D4E] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#5C635C]">{error ? "ההתחברות נכשלה, מעבירים אותך חזרה..." : "מתחברים לחשבון שלך..."}</p>
      </div>
    </div>
  );
}
